import  { useContext, useState } from "react";
import { Colour, FontType, Tsize, Header, UserAudios, Bplay, Hindit, IskconContent } from "../global";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import ScrollToTop from "../scroll";
import { IonCard, IonCardContent, IonToolbar, IonButton, IonButtons, IonLabel, IonPage, IonHeader, IonContent } from "@ionic/react";

import { ArrowBackSharp, MenuBookSharp } from "@mui/icons-material";
import { motion } from "framer-motion";
import { MoreVertSharp } from "@mui/icons-material";
import { Helmet } from "react-helmet";
import YouTubePlayer from "../music/youtubeplayer";
import Music from "../music/music";
import SP from "../../sp.svg";

export default function Tsong(props) {
 let [tiskcon, ] = props.value;
 let { ind } = useParams();
 let nind = Number(ind);
 let fun = tiskcon.songs[nind].body;
 let vtext = fun.split(/\r\n|\n/);
 let history = useHistory();
 const [tsize, ] = useContext(Tsize);
 let {  url } = useRouteMatch();
 const [header, ] = useContext(Header);
 const [anchorEl, setAnchorEl] = useState(null);
 const [hindit, ] = useContext(Hindit);
 const [iskcon, ] = useContext(IskconContent);


 let [clr, ] = useContext(Colour);
 let color,color2,color3,colori,colorh;
 if(clr === "1") {
  color = "#00CBFE";
  color2 = "#04010f";
  color3 = "black"
  colori = "light"
  colorh = "primary"
 }
 if(clr === "2") {
  color = "#FFE34D";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "warning"
 }
 if(clr === "3") {
  color = "#FFA500";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "success"
 }
 if(clr === "4") {
  color = "#87CEEB";
  color2 = "#04010f";
  color3 = "black"
  colori = "secondary"
  colorh = "tertiary"
 }
 if(clr === "5") {
  color = "#181818";
  color2 = "#F5F5F5";
  color3 = "white"
  colori = "dark"
  colorh = "warning"
 }
 if(clr === "6") {
  color = "#181818";
  color2 = "#F5F5F5";
  color3 = "white"
  colori = "dark"
  colorh = "tertiary"
 }
 const [font, ] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";

 const [userAudios, ] = useContext(UserAudios)
 const songName = tiskcon.songs[nind].name;
 const [, setBplay] = useContext(Bplay);
 const [spv, setSpv] = useState(tiskcon.songs[nind].vname && hindit ? false : true)


 function goback() {
  setBplay({ fold: 0, song: 0 });
  if(history.length > 1){
    history.goBack()
  }else{
    history.push(url.slice(0, url.lastIndexOf("/")));
  }
 }

 let iarr = [];
 let present = 0;
 let vname = tiskcon.songs[nind].vname;
 let index = 1;
 let vindex = 0;
 for (let i in iskcon.songs) {
  if (iskcon.songs[i].name === vname) {
   vindex = i;
   break;
  }
 }
 let ifun =
  hindit && iskcon.songs[vindex].hindi
   ? iskcon.songs[vindex].hbody
   : iskcon.songs[vindex].body;

 while (true) {
  if (ifun.indexOf("(" + index.toString() + ")", present) !== -1) {
   present = ifun.indexOf("(" + index.toString() + ")", present);
   iarr.push(index.toString());
   index++;
  } else {
   break;
  }
 }


 const toolbar =   <IonToolbar color={colorh}>
 <IonButtons slot="start" onClick={goback}>
  <IonButton>
  <ArrowBackSharp style={{ fontSize: 30 }} />
  </IonButton>
 </IonButtons>
 <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? tiskcon.songs[nind].hname : tiskcon.songs[nind].name}</IonLabel>
 {tiskcon.songs[nind].vname ? (spv ? (
    <IonButtons slot="end">
     <IonButton
      onClick={() => {
       setSpv(!spv);
      }}
     >
      <img alt="" src={SP} style={{ height: "25px", borderRadius:"50%" }} />
     </IonButton>
    </IonButtons>
   ) : (
    <IonButtons slot="end">
     <IonButton
      onClick={() => {
       setSpv(!spv);
      }}
     >
      <MenuBookSharp />
     </IonButton>
    </IonButtons>
   )) : null}
 <IonButtons slot="end">
   <IonButton
   style={{marginRight:"7px"}}
    onClick={(e) => {
      setAnchorEl(e.currentTarget);
    }}
   >
    <MoreVertSharp />
   </IonButton>
  </IonButtons>
</IonToolbar>;

 return (
  <IonPage>
   <Helmet>
      <title>{tiskcon.songs[nind].name}</title>
      <meta name="description" content={tiskcon.songs[nind].name} />
  </Helmet>
   <ScrollToTop />
   {!(userAudios[songName] && userAudios[songName].type === "youtube") && header==="true" ? <IonHeader className="lhide print-hide">
      {toolbar}
    </IonHeader> : null}
    {(userAudios[songName] && userAudios[songName].type === "youtube") ? <YouTubePlayer
    colorh={colorh}
    userAudios={userAudios}
    name={songName}
     /> : null}
   <IonContent  color={colori} >

   {((userAudios[songName] && userAudios[songName].type === "youtube") || header !== "true") ? <div className="lhide print-hide">{toolbar}</div> : null} 
   <div className="phide print-hide">{toolbar}</div>
   <motion.div
    exit={{
     opacity: 0,
    }}
    animate={{ opacity: 1 }}
    initial={{ opacity: 0 }}
    transition={{ type: "linear", duration: 1 }}
   >

  {spv ?<> <div className="print-visible" style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 0 0", fontFamily: `${fon}` }}>
    <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}`, padding:0, marginBottom:0 }}>
    <IonCardContent style={{padding:0}}>
    <div style={{ textAlign: "center", color: `${color3}`, fontSize: `${(Number(tsize)+8)}px` }}>
    {songName}
    </div>
    </IonCardContent>
   </IonCard>
   </div>
   
    <div style={{ marginTop: 0, borderTop: 0, marginBottom: 0, borderBottom: 0, backgroundColor: `${color}`, padding: "4px 0 2px 0" }}>
     <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
      <IonCardContent>
      
       <div style={{ lineHeight: "1.5" }}>
        {vtext.map((td, i) => {
         let k = 0,
          j = td.length;
         for (let i in td) {
          if (td[i] === " ") k++;
          else break;
         }

         for (let i in td) {
          if (td[td.length - 1 - i] === " ") j--;
          else break;
         }

         td = td.slice(k, j);

         if (i === 0)
          return (
           <div key={i}>
            <div style={{ textAlign: "center", fontSize: `${tsize}px` }}>{td}</div>
            <br />
           </div>
          );

         if (td[0] === "." && td[1] === ".") return <div key={i} style={{ textAlign: "center", fontSize: `${tsize}px` }}>{td}</div>;
         if (i === vtext.length - 1) return null;
         if (td[0] === "[" && vtext[i - 1] === "[") return null;
         if (td[0] === "[" && vtext[i - 1] !== "[")
          return (
           <div key={i}>
           
           </div>
          );

         if (td[0] === "6" || td[0] === "7") return null;
         if (td === "Purport by His Divine Grace")
          return (
           <div key={i}>
            <br />
            <div style={{ fontSize: `${tsize}px`, textAlign: "justify" }}>Purport by His Divine Grace A.C. Bhaktivedanta Swami Prabhupāda</div>
            <br />
           </div>
          );
         if (td === "A.C. Bhaktivedanta Swami Prabhupāda") return null;
         if (td === "Hare Kṛṣṇa, Hare Kṛṣṇa, Kṛṣṇa Kṛṣṇa, Hare Hare")
          return (
           <div key={i}>
            <br />
            <div style={{ textAlign: "center", fontSize: `${tsize}px` }}>Hare Kṛṣṇa, Hare Kṛṣṇa, Kṛṣṇa Kṛṣṇa, Hare Hare</div>
           </div>
          );
         if (td === "Hare Rāma, Hare Rāma, Rāma Rāma, Hare Hare")
          return (
           <div key={i}>
            <div style={{ textAlign: "center", fontSize: `${tsize}px` }}>Hare Rāma, Hare Rāma, Rāma Rāma, Hare Hare</div>
            <br />
           </div>
          );

         if ((td[0] >= "*" && td[0] <= "`") || td[0] === "Ś" || td[0] === '"' || td[0] === "“") {
          return (
           <div key={i}>
            <br />
            <div style={{ fontSize: `${tsize}px`, textAlign: "justify" }}>{td}</div>
            <br />
           </div>
          );
         } else return <div key={i} style={{ textAlign: "center", fontSize: `${tsize}px` }}>{td}</div>;
        })}
       </div>
      </IonCardContent>
     </IonCard>
    </div> </>:  <div style={{ backgroundColor: `${color}`, margin: "0", padding: "4px 0 2px 0" }}>
 <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
  <IonCardContent>
   {iarr.map((sent, i) => {
    let ind1 = ifun.indexOf("(" + sent + ")");
    let ind2 = ifun.indexOf(i < iarr.length - 1 ? "(" + iarr[i + 1] + ")" : "TRANSLATION");

    let zen = ifun.slice(ind1, ind2);
    let ztext = zen.split(/\r\n|\n/);

    if (i === 0 && ifun.indexOf("(refrain)") !== -1) {
     let indr = ifun.indexOf("(refrain)");

     let zenr = hindit && iskcon.songs[vindex].hindi ? ifun.slice(indr, ind1).replace("(refrain)", "(टेक)") : ifun.slice(indr, ind1);
     let ztextr = zenr.split(/\r\n|\n/);

     return (
      <div key={i}>
       <div>
        {ztextr.map((vad, j) => {
         return <div key={j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
        })}
       </div>

       <div>
        {ztext.map((vad, j) => {
         return <div key={j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
        })}
       </div>
      </div>
     );
    }

    return (
     <div key={i}>
      {ztext.map((vad, j) => {
       return <div key={j} style={{ textAlign: "center", color: `${color3}`, fontSize: `${tsize}px` }}>{vad}</div>;
      })}
     </div>
    );
   })}{" "}
  </IonCardContent>
 </IonCard>

 <IonCard color={colori} style={{ color: `${color2}`, fontFamily: `${fon}` }}>
  <IonCardContent>
   <div style={{ textAlign: "center", fontSize: `${tsize}px` }}>{hindit && iskcon.songs[vindex].hindi ? "अर्थ" : "Translation"}</div>
   {iarr.map((sent, i) => {
    let ind3 = ifun.indexOf(sent + ")", ifun.indexOf("TRANSLATION"));
    let ind4 = ifun.indexOf(i < iarr.length - 1 ? iarr[i + 1] + ")" : "Song Name", ifun.indexOf("TRANSLATION"));

    let zen1 = hindit && iskcon.songs[vindex].hindi ? ifun.slice(ind3, ind4 - 1) : ifun.slice(ind3, ind4);
    let ztext1 = zen1.split(/\r\n|\n/);

    if (ztext1[0].length < 5) return null;
    else {
     if (i === 0 && ifun.indexOf("(refrain)") !== -1) {
      let indR = ifun.indexOf("Refrain:");

      let zenR = hindit && iskcon.songs[vindex].hindi ? ifun.slice(indR, ind3 - 1).replace("Refrain", "टेक") : ifun.slice(indR, ind3);
      let ztextR = zenR.split(/\r\n|\n/);

      return (
       <div key={i}>
        <div>
         <br />
         {ztextR.map((vad1, j) => {
          return <div key={j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
         })}
        </div>

        <div>
         <br />
         {ztext1.map((vad1, j) => {
          return <div key={j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
         })}
        </div>
       </div>
      );
     }

     return (
      <div key={i}>
       <br />
       {ztext1.map((vad1, j) => {
        return <div key={j} style={{ fontSize: `${tsize}px`, textAlign: "justify", textJustify: "auto" }}>{vad1}</div>;
       })}
      </div>
     );
    }
   })}
  </IonCardContent>
 </IonCard>
</div>}
   </motion.div>
   </IonContent>
   <Music
   songName = {songName}
   hsongName = {tiskcon.songs[nind].hname}
   songList = {[{"linkname": "Srila Prabhupada", "linkaddress": tiskcon.songs[nind].link, "hlinkname": "श्रील प्रभुपाद"}]}
   songPath = {url}
   colorh={colorh}
   fon={fon}
   colori={colori}
   anchorEl={anchorEl}
   setAnchorEl={setAnchorEl}
   share_url={`https://vsnectar.web.app${url}`}
    />
  </IonPage>
 );
}
